<h1 mat-dialog-title>Kies je tags</h1>

<mat-dialog-content class="flex! flex-col">
  <div class="flex items-center gap-2">
    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
    >
      <mat-icon matPrefix> search </mat-icon>

      <input
        #searchInput
        matInput
        placeholder="Zoeken op naam..."
        [ngModel]="keyword()"
        (ngModelChange)="handleSearch(searchInput.value)"
      />

      @if (keyword()) {
        <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  @if (isClientScoped()) {
    <div class="flex items-center gap-3 mt-3 px-3 py-2.5 rounded-lg bg-blue-50 text-blue-800 text-xs leading-relaxed">
      <mat-icon class="text-blue-500 shrink-0 text-lg!">info</mat-icon>
      <span>Alleen tags die in de interacties van deze cliënt worden gebruikt, worden hier weergegeven.</span>
    </div>
  }

  <div class="pt-6 pb-2 text-sm font-medium">
    @if (maxSelectionLimit(); as limit) {
      {{ selection().selectedOptions.selected.length }} van {{ limit }} tag(s)
      geselecteerd
    } @else {
      {{ selection().selectedOptions.selected.length }} tag(s) geselecteerd
    }
  </div>

  <div class="-mx-6 py-2 border-y border-gray-200 overflow-auto scrollbar-width-thin">
    <div class="flex flex-col gap-8 min-h-70">
      <div class="px-6">
        <div class="text-sm font-medium pt-2 pb-4">Tags</div>

        <mat-selection-list class="p-0!" [multiple]="multiple" [disabled]="submitted()">
          @for (item of filteredTags(); track item.id) {
            <mat-list-option
              togglePosition="before"
              [value]="item"
              [disabled]="isItemDisabled(item)"
              [matTooltip]="isAlreadyAdded(item) ? 'Al toegevoegd' : item.label"
              matTooltipPosition="after"
              class="pl-2! select-none [--mdc-list-list-item-disabled-state-layer-color:transparent] [--mdc-list-list-item-hover-state-layer-color:var(--color-gray-200)] [--mdc-list-list-item-hover-state-layer-opacity:1] [--mdc-list-list-item-container-shape:var(--radius-lg)]"
            >
              <div class="flex items-center gap-4">
                <div class="text-sm truncate">
                  {{ item.label }}
                </div>
              </div>
            </mat-list-option>
          } @empty {
            <p>Er zijn geen tags om te selecteren.</p>
          }
        </mat-selection-list>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || !selection().selectedOptions.selected.length"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
